import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import IconButton from '../iconButton/iconButton.js';
import HelpIcon from '../../panels/headerHelp-svg.js';
import CloseIcon from '../../panels/headerCloseButton.svg.js';
import { dataHooks } from './constants';

var BaseModalHeader = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(BaseModalHeader, _React$PureComponent);

  var _super = _createSuper(BaseModalHeader);

  function BaseModalHeader() {
    _classCallCheck(this, BaseModalHeader);

    return _super.apply(this, arguments);
  }

  _createClass(BaseModalHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          onCloseButtonClick = _this$props.onCloseButtonClick,
          onHelpButtonClick = _this$props.onHelpButtonClick; // TODO: change icons #EK-2177

      return /*#__PURE__*/React.createElement("div", {
        className: classNames('control-base-modal-header', className)
      }, children, /*#__PURE__*/React.createElement("div", {
        className: "control-base-modal-header-btn-bar"
      }, onHelpButtonClick && /*#__PURE__*/React.createElement(IconButton, {
        skin: "light-dark",
        className: "control-base-modal-header-btn control-base-modal-header-btn-help",
        onClick: onHelpButtonClick,
        dataHook: dataHooks.helpButton
      }, /*#__PURE__*/React.createElement(HelpIcon, null)), onCloseButtonClick && /*#__PURE__*/React.createElement(IconButton, {
        skin: "light-dark",
        className: "control-base-modal-header-btn control-base-modal-header-btn-close",
        onClick: onCloseButtonClick,
        dataHook: dataHooks.closeButton
      }, /*#__PURE__*/React.createElement(CloseIcon, null))));
    }
  }]);

  return BaseModalHeader;
}(React.PureComponent);

BaseModalHeader.displayName = displayNames.BASE_MODAL_HEADER;
BaseModalHeader.propTypes = {
  /** A css class to be applied to the component's root element */
  className: PropTypes.string,

  /** callback for when the close button is clicked */
  onCloseButtonClick: PropTypes.func,

  /** callback for when the help button is clicked */
  onHelpButtonClick: PropTypes.func
};
BaseModalHeader.defaultProps = {};
export default compose(BaseModalHeader);